import { DiagramDefinition } from "../types";

export const m015Definition: DiagramDefinition = {
  id: "M-015",
  title: "Migration Lifecycle Flow",
  description:
    "Lifecycle of database schema migrations from automatic startup checks, up function execution, log updates, schema synchronization, through CLI/programmatic rollback down functions.",
  viewBox: "0 0 1100 360",
  nodes: [
    { id: "A", kind: "service", label: "Server Start", subtext: "Bootstrap Check", position: [100, 100], size: [130, 46] },
    { id: "B", kind: "decision", label: "Pending?", subtext: "Compare Tracking", position: [320, 100], size: [150, 46] },
    { id: "C", kind: "service", label: "Run up()", subtext: "Execute Migration", position: [540, 60], size: [130, 44], statusColor: "#ff5a1f" },
    { id: "D", kind: "database", label: "Update Log", subtext: "_migrations Table", position: [760, 60], size: [130, 44] },
    { id: "E", kind: "service", label: "Schema Sync", subtext: "Reflect Changes", position: [980, 60], size: [130, 44] },
    { id: "F", kind: "service", label: "Skip Check", subtext: "No Pending Files", position: [540, 150], size: [130, 42] },
    { id: "G", kind: "status", label: "Server Ready", subtext: "API Active", position: [980, 150], size: [130, 44], statusColor: "#22c55e" },

    // Rollback Lifecycle
    { id: "H", kind: "client", label: "Run Rollback", subtext: "solarch migrate down", position: [100, 270], size: [140, 46] },
    { id: "I", kind: "service", label: "Run down()", subtext: "Revert Changes", position: [320, 270], size: [130, 44], statusColor: "#f59e0b" },
    { id: "J", kind: "database", label: "Revert Log", subtext: "Delete Row", position: [540, 270], size: [130, 44] },
    { id: "K", kind: "service", label: "Schema Sync", subtext: "Reflect Revert", position: [760, 270], size: [130, 44] },
  ],
  edges: [
    { id: "e1", source: "A", target: "B", sourcePort: "right", targetPort: "left", routing: "straight", animated: true },
    { id: "e2", source: "B", target: "C", label: "Yes", sourcePort: "right", targetPort: "left", routing: "orthogonal" },
    { id: "e3", source: "C", target: "D", sourcePort: "right", targetPort: "left", routing: "straight" },
    { id: "e4", source: "D", target: "E", sourcePort: "right", targetPort: "left", routing: "straight" },
    { id: "e5", source: "E", target: "G", sourcePort: "bottom", targetPort: "top", routing: "straight" },
    { id: "e6", source: "B", target: "F", label: "No", sourcePort: "right", targetPort: "left", routing: "orthogonal" },
    { id: "e7", source: "F", target: "G", sourcePort: "right", targetPort: "left", routing: "straight" },
    { id: "e8", source: "H", target: "I", sourcePort: "right", targetPort: "left", routing: "straight", animated: true },
    { id: "e9", source: "I", target: "J", sourcePort: "right", targetPort: "left", routing: "straight" },
    { id: "e10", source: "J", target: "K", sourcePort: "right", targetPort: "left", routing: "straight" },
  ],
};
